import { render, staticRenderFns } from "./PackageHistory.vue?vue&type=template&id=128cac1a&scoped=true"
import script from "./PackageHistory.vue?vue&type=script&lang=js"
export * from "./PackageHistory.vue?vue&type=script&lang=js"
import style0 from "./PackageHistory.vue?vue&type=style&index=0&id=128cac1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128cac1a",
  null
  
)

export default component.exports